module.exports = __webpack_public_path__ + "static/canyon-sunrise-57843b6ba2197f6b841426abebca8790.jpg";